import React from "react";
import "./Work.css";
import check from "../../assets/images/Lp/check.png";
import cross from "../../assets/images/Lp/cross.png";
import Work_img from "../../assets/images/Lp/work-img.jpg";
import Image02 from "../../assets/images/Lp/fam-icon-02.png";
import Image03 from "../../assets/images/Lp/fam-icon-03.png";
import Image04 from "../../assets/images/Lp/fam-icon-04.png";
import Image05 from "../../assets/images/Lp/fam-icon-05.png";

export default function Familiar({ id }) {
  return (
    <div id={id} className="section py-constant">
      <div className="container">
        <h2 className="h2 title center">How does it work?</h2>
        <div className="flex flex-row work-inner">
          <div className="left-area">
            <div className="list">
              <div className="list-item">
                Install the CustomerGenius Shopify App.
              </div>
              <div className="list-item">Select discounts to monitor.</div>
              <div className="list-item">
                Let our advanced algorithms automatically detect suspicious
                orders.
              </div>
              <div className="list-item">
                Review flagged orders via instant email notifications
                (optional).
              </div>
            </div>
          </div>

          <div className="youtube-video">
            <iframe
              src="https://www.youtube.com/embed/RrjKk5AKAys"
              title="How CustomerGenius Works"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              loading="lazy"
            />
          </div>


          <div className="right-area">
            <div className="list">
              <div className="list-item">
                Refund & Cancel suspicious orders manually or automatically.
              </div>
              <div className="list-item">
                Notify suspicious customers with customizable automated emails
                (optional).
              </div>
              <div className="list-item">
                Track & Report monthly savings from prevented fraud.
              </div>
            </div>
          </div>
        </div>

        <a
          href="https://apps.shopify.com/customergenius"
          className="button button--primary bottom"
        >
          Start Catching Abusers Today with a 14 Day Free Trial!
        </a>
      </div>
    </div>
  );
}
